'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checked: _this.props.checkedValues ? (0, _utils.includes)(_this.props.checkedValues, _this.props.value) : Boolean(_this.props.isChecked)
    }, _this.handleChange = function (e) {
      var checked = !_this.state.checked;
      _this.setState({ checked: checked });
      if (_this.props.onChange) {
        _this.props.onChange(checked, _this.props.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Checkbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.checkedValues != null) {
        var checked = (0, _utils.includes)(nextProps.checkedValues, nextProps.value);
        this.setState({ checked: checked });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          disabled = _props.disabled,
          value = _props.value,
          _props$id = _props.id,
          id = _props$id === undefined ? (0, _utils.idGen)('checkbox') : _props$id,
          inputClassName = _props.inputClassName,
          labelClassName = _props.labelClassName,
          name = _props.name;
      var checked = this.state.checked;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('luna-form__selection', className) },
        _react2.default.createElement('input', {
          id: id,
          value: value && (0, _utils.stringify)(value),
          className: (0, _classnames2.default)('luna-checkbox', inputClassName),
          type: 'checkbox',
          name: name,
          disabled: disabled,
          checked: checked,
          onChange: this.handleChange
        }),
        _react2.default.createElement(
          'label',
          { className: (0, _classnames2.default)('luna-label', labelClassName), htmlFor: id },
          label
        )
      );
    }
  }]);

  return Checkbox;
}(_react.Component);

Checkbox.propTypes = {
  isChecked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  name: _propTypes2.default.string,
  id: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object]),
  onChange: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  inputClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  labelClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};
exports.default = Checkbox;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Checkbox/Checkbox.js